import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBolt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeWidth={1.3}
        d="M15.463 3.944c.463-1.477-1.285-2.64-2.295-1.458l-7.807 9.128c-.797.933-.19 2.456 1.004 2.456h3.756c.128 0 .23.137.186.282l-1.687 5.73c-.436 1.48 1.315 2.607 2.31 1.424l7.717-9.179c.786-.935.177-2.446-1.011-2.446h-3.757c-.129 0-.23-.14-.185-.286z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBolt);
export default ForwardRef;
